module.exports = __webpack_public_path__ + "static/media/66.11437973.JPG";